module.exports = __webpack_public_path__ + "img/totalOrder.765740f2.svg";